import { z } from "zod";

/** 24-character hexadecimal MongoDB ObjectId string (no mongoose dependency). */
export const OBJECT_ID_HEX_REGEX = /^[0-9a-fA-F]{24}$/;

/**
 * Zod schema for a Mongo ObjectId hex string. Prefer this over bare `z.string()` for id fields:
 * empty or non-hex values would otherwise pass validation and throw in `new ObjectId(...)` at the
 * service boundary.
 */
export const objectIdStringSchema = z
  .string()
  .regex(OBJECT_ID_HEX_REGEX, "Must be a 24-character hex ObjectId string.");
